import SimpleKpiCard from "../../../component/simpleKpiCard"
import CardBadgeDeltaChart from "../../../component/cardBadgeDelta"
import { useSelector } from "react-redux"
import { Box, Card, Typography, Grid } from "@mui/material"
import { OccupationRealTimeKPI, OrderCountRealTimeKPI } from "../../helper"
import useTrademarkFilter from "../../../../hooks/useTrademarkFilter"

export default function CardInfoRealtime() {
    const kpiRealTime = useSelector((state) => state.kpiRealTime)

    // faz o filtro das listas de realtime por marca selecionada pelo usuário
    const filteredKpiRealTime = useTrademarkFilter(kpiRealTime)

    const cardOccupationKPI = OccupationRealTimeKPI(filteredKpiRealTime)
    const cardorderCountRealTimeKPI = OrderCountRealTimeKPI(filteredKpiRealTime)

    return (
        <Card
            sx={{
                p: 3,
                borderRadius: 2,
                backgroundColor: (theme) => theme.palette.personal.background,
            }}
        >
            <Box sx={{ mb: 3, display: "flex" }}>
                <Typography variant="h3">
                    Seu negócio agora
                </Typography>
            </Box>

            <Grid container spacing={1.5}>
                <Grid item xs={12} md={6} lg={6}>
                    <CardBadgeDeltaChart {...cardOccupationKPI} />
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                    <SimpleKpiCard {...cardorderCountRealTimeKPI} />
                </Grid>
            </Grid>
        </Card>
    )
}